export const TemplateTypes = {
  cartAbandonment: 'cartAbandonment',
  browseAbandonment: 'browseAbandonment',
  unsubscribe: 'unsubscribe',
  /* 
    NOTE: Email acquisition has been renamed to data acquisition to account for the additional data points we capture.
    The value has been purposely left as emailAcquisition as the backend will not migrate to the new value.
  */
  dataAcquisition: 'emailAcquisition',
  globalUnsubscribe: 'globalUnsubscribe',
  /** Gallery filter for global-site email tracking opt-out pages (stored template.type is unsubscribeEmailTracking). */
  globalUnsubscribeEmailTracking: 'globalUnsubscribeEmailTracking',
  /** Stored template.type for email tracking opt-out pages (site and global site). */
  unsubscribeEmailTracking: 'unsubscribeEmailTracking',
  sendMyBasket: 'sendMyBasket',
  displayOnly: 'displayOnly',
  mpsEmbed: 'mpsEmbed',
  mpsPopup: 'mpsPopup',
  bulkRetargeting: 'bulkRetargeting',
};
